export default "__VITE_ASSET__DrLTaVcm__"